const getDefaultHTML = () => {
  return `<div class="trix-button-row">
    <div class="btn-group mb-1" data-trix-button-group="text-tools">
      <button type="button" class="btn btn-sm btn-outline-primary" data-trix-attribute="bold" data-trix-key="b" title="Bold" tabindex="-1"><i class="fas fa-bold"></i></button>
      <button type="button" class="btn btn-sm btn-outline-primary" data-trix-attribute="italic" data-trix-key="i" title="Italic" tabindex="-1"><i class="fas fa-italic"></i></button>
      <button type="button" class="btn btn-sm btn-outline-primary" data-trix-attribute="href" data-trix-action="link" data-trix-key="k" title="Link" tabindex="-1"><i class="fas fa-link"></i></button>
    </div>
  </div>

  <div class="trix-dialogs" data-trix-dialogs>
    <div class="trix-dialog trix-dialog--link" data-trix-dialog="href" data-trix-dialog-attribute="href">
      <div class="trix-dialog__link-fields">
        <input type="url" name="href" class="trix-input trix-input--dialog" placeholder="Enter a URL..." aria-label="URL" data-trix-validate-href required data-trix-input>
        <div class="trix-button-group">
          <input type="button" class="trix-button trix-button--dialog" value="Link" data-trix-method="setAttribute">
          <input type="button" class="trix-button trix-button--dialog" value="Unlink" data-trix-method="removeAttribute">
        </div>
      </div>
    </div>
  </div>`
}

export { getDefaultHTML }
